const LOGO_URL = "https://customer-assets.emergentagent.com/job_vets-intake-demo/artifacts/e4mtecfo_Untitled%20design%20%2892%29.png";

export const IntakePage = () => {
  return (
    <div className="page-transition min-h-screen bg-paper-white" data-testid="intake-page">
      {/* Hero Section */}
      <section className="bg-wv-blue py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-6 mb-4">
            <img 
              src={LOGO_URL} 
              alt="Worthy Vets Service Group" 
              className="h-16 w-auto hidden md:block"
            />
            <div>
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-white uppercase tracking-wide">
                Request Assistance
              </h1>
              <p className="text-xl text-white/80 mt-2">
                Complete this form to start your journey. We will review your information and reach out.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* JotForm Section */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div 
            className="bg-white rounded-lg shadow-lg border-2 border-gray-100 overflow-hidden"
            data-testid="jotform-container"
          >
            <iframe
              id="JotFormIFrame-260778238690065"
              title="Worthy Vets Service Group - Client Intake Form"
              src="https://form.jotform.com/260778238690065"
              style={{
                minWidth: '100%',
                maxWidth: '100%',
                height: '800px',
                border: 'none'
              }}
              scrolling="yes"
              allowFullScreen
            />
          </div>
        </div>
      </section>
    </div>
  );
};
